import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';

@Component({
  selector: 'app-r-q2',
  templateUrl: './r-q2.component.html',
  styleUrls: ['./r-q2.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ2Component implements OnInit {
  @Input() data: any;
  public service: any;
  public hgService;
  isChecked;
  showbutton = true;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  deviceWidth;
  service1_id;
  service2_id;
  ns_src;
  sp_src;
  timer;
  question_sub1;
  question_sub2;
  question_sub3;
  question_sub4;

  addAddressFlow = false;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    // console.log.log(this.deviceWidth);
    this.hgService = {
      ns: false,
      sp: false,
    };
  }

  ngOnInit() {
    this.getProviderInfo();
    this.residentialService.currentId = this.data;
    // To check the flow is from another address - If add another address flow quit this question
    // To get the accountId from url
    const url = window.location.href;
    const urlArr = url.split('/');
    // console.log.log('urlParts::::' + urlArr.length);
    if (
      urlArr &&
      urlArr.length !== 0 &&
      urlArr[4] === 'residentialQues' &&
      urlArr[5] === 'add-address'
    ) {
      this.addAddressFlow = true;
    }
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ nextId: '0014' });
    }

    if (this.deviceWidth < 768) {
      this.service1_id = document.getElementById('NewService_mob');
      this.service2_id = document.getElementById('SwitchingProviders_mob');
    } else {
      this.service1_id = document.getElementById('NewService');
      this.service2_id = document.getElementById('SwitchingProviders');
    }
    const userObj = JSON.parse(sessionStorage.getItem('userObj'));

    // console.log.log(this.data);
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;

        if (!_.isEmpty(userObj)) {
          this.question = "Thanks for coming back [first name]! What brings you here today? "
        }
        // If the flow is from add-address -> show 'add-address' text
        if (this.addAddressFlow) {
          this.question = this.questions[i].add_address;
          // this.question = 'Hi [first name]! I appreciate you wanting to add another address. So that I can best serve you, '+
          //   'I will be asking the same questions since each premise and its use is different. Tell me, what brings you here today?';
        }
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    // to get the user name from login user obj
    
    let questionName = !_.isEmpty(this.userResponses[0])
      ? this.userResponses[0].fieldValue.toString().replace(/\s+$/, '')
      : '';
    if (!_.isEmpty(userObj)) {
      questionName = userObj['userName']
        ? this.titleCase(userObj['userName'])
        : '';
    }
    this.question = this.question.replace(
      '[first name]',
      this.titleCase(questionName == '' ? userObj['fName']  : questionName)
    );
    if (this.addAddressFlow) {
      const splitQuestion = this.question.split('another ');
      this.question_sub1 = splitQuestion[0] + 'another';
      const splitQuestion1 = splitQuestion[1].split('asking ');
      this.question_sub2 = splitQuestion1[0] + 'asking';
      const splitQuestion2 = splitQuestion1[1].split('is ');
      this.question_sub3 = splitQuestion2[0] + 'is';
      this.question_sub4 = splitQuestion2[1];
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        res_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.service = obj.fieldValue;
        if (!_.isEmpty(this.service)) {
          this.isChecked = true;
          if (this.service === 'New Service') {
            this.ns_src = 'assets/images/new-service-pink.png';
            this.sp_src = 'assets/images/switch-providers-gray.png';
            this.hgService = {
              ns: true,
              sp: false,
            };
            this.service1_id.parentElement.parentElement.classList.add(
              'active-select'
            );
          } else {
            this.ns_src = 'assets/images/new-service-gray.png';
            this.sp_src = 'assets/images/switch-providers-pink.png';
            this.hgService = {
              ns: false,
              sp: true,
            };
            this.service2_id.parentElement.parentElement.classList.add(
              'active-select'
            );
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.next();
          }
        } else {
          this.sp_src = 'assets/images/switch-providers-gray.png';
          this.ns_src = 'assets/images/new-service-gray.png';
        }
      } else {
        this.sp_src = 'assets/images/switch-providers-gray.png';
        this.ns_src = 'assets/images/new-service-gray.png';
      }
    } else {
      this.sp_src = 'assets/images/switch-providers-gray.png';
      this.ns_src = 'assets/images/new-service-gray.png';
    }

    if(!this.isChecked)
    {
      this.showbutton = false;
    }

  }

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  getService(event) {
    this.service = event.target.value;
    this.isChecked = event.target.checked;
    this.user_bot = true;
    if (this.isChecked === true) {
      if (this.service === 'New Service') {
        this.ns_src = 'assets/images/new-service-pink.png';
        this.sp_src = 'assets/images/switch-providers-gray.png';
        if (
          _.contains(
            this.service2_id.parentElement.parentElement.classList,
            'active-select'
          )
        ) {
          this.service2_id.parentElement.parentElement.classList.remove(
            'active-select'
          );
        }
        this.service1_id.parentElement.parentElement.classList.add(
          'active-select'
        );
        this.hgService = {
          ns: true,
          sp: false,
        };
      } else {
        this.ns_src = 'assets/images/new-service-gray.png';
        this.sp_src = 'assets/images/switch-providers-pink.png';
        if (
          _.contains(
            this.service1_id.parentElement.parentElement.classList,
            'active-select'
          )
        ) {
          this.service1_id.parentElement.parentElement.classList.remove(
            'active-select'
          );
        }
        this.service2_id.parentElement.parentElement.classList.add(
          'active-select'
        );
        this.hgService = {
          ns: false,
          sp: true,
        };
      }
    } else {
      this.sp_src = 'assets/images/switch-providers-gray.png';
      this.ns_src = 'assets/images/new-service-gray.png';
      this.hgService = {
        ns: false,
        sp: false,
      };
      this.service = '';
      this.user_bot = false;
      if (
        _.contains(
          this.service1_id.parentElement.parentElement.classList,
          'active-select'
        )
      ) {
        this.service1_id.parentElement.parentElement.classList.remove(
          'active-select'
        );
      }
      if (
        _.contains(
          this.service2_id.parentElement.parentElement.classList,
          'active-select'
        )
      ) {
        this.service2_id.parentElement.parentElement.classList.remove(
          'active-select'
        );
      }
    }

    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if(!this.showbutton)
      {
        this.next();
      }

    }

  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  next() {
    if (_.isEmpty(this.service)) {
      // alert('Select the Service');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
    } else {
      this.residentialService.setServiceType(this.service);
      this.residentialService.messageService({
        currentId: this.data,
        service: this.service,
      });
      // console.log.log('hello');
    }
  }

  // This function is used for to save the data in DB
  save() {
    const Obj = {
      res_question_id: this.data,
      fieldName: 'service',
      fieldValue: this.service,
    };
    if (this.addAddressFlow) {
      this.residentialService.userResponse.userResponses = [];
    }
    this.residentialService.updateResponses(Obj);
    this.residentialService.userResponse.userResponses.length = 2;
  }

  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails('4Change Energy', 'Oncor')
      .subscribe((res: any) => {
        this.residentialService.providerContact = res[0];
      });
  }
}
